export default "__VITE_ASSET__C3NWDIq5__"